module.exports = __webpack_public_path__ + "img/logo-h-250x50.d55b35be.png";